import { Draft, DraftUtils, Form, FormStore, Review } from 'bz-draft';
import { inject, observer } from 'mobx-react';

import React from 'react';

@inject('report')
@observer
class DraftReport extends React.Component {
  constructor(props) {
    super(props);

    let { report } = this.props;
    this.store = new FormStore(DraftUtils.getClinicalControls());
    this.store.mode = report.mode !== 'draft' ? 'live' : 'draft';
    this.store.readOnly = report.mode === 'review';
    this.store.onDataChange = this.onChange.bind(this);
    report.applyValidation = this.applyValidation.bind(this);
    this.store.load(report.template, report.data);
    this.store.loading = false;
  }

  applyValidation() {
    return new Promise((resolve, reject) => {
      this.store.submitted = true;
      let valid = this.store.onValidate();
      resolve(valid);
    });
  }

  render() {
    switch (this.props.report.mode) {
      case 'draft':
        return <Draft store={this.store} />;
      case 'form':
        return <Form store={this.store} />;
      default:
        return <Review store={this.store} />;
    }
  }

  onChange() {
    this.props.onStateChange(this.store.data);
  }
}

export default DraftReport;
